import __request__ from "routing/request";
export function retrieve(JSONbody) {
  return __request__("POST", "/views/search/messages", JSONbody, {}, {
    "Accept": ["text/csv"]
  });
}
export function retrieveForExportJob(exportJobId, filename) {
  return __request__("GET", `/views/search/messages/job/${exportJobId}/${filename}`, null, {}, {
    "Accept": []
  });
}
export function retrieveForSearch(searchId, Optionaloverrides) {
  return __request__("POST", `/views/search/messages/${searchId}`, Optionaloverrides, {}, {
    "Accept": ["text/csv"]
  });
}
export function retrieveForSearchType(searchId, searchTypeId, Optionaloverrides) {
  return __request__("POST", `/views/search/messages/${searchId}/${searchTypeId}`, Optionaloverrides, {}, {
    "Accept": []
  });
}
